import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
  ViewChild
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { EMPTY, Subject, Subscription, combineLatest, forkJoin, interval, switchMap, takeWhile, throwError } from "rxjs";
import { catchError, debounceTime, distinctUntilChanged, tap } from "rxjs/operators";
import { ProjectConfigsService } from "src/app/akita/project-configs/state/project-configs.service";
import { MapService } from "src/app/core/service/api/map.service";
import { arcGisSectionEnabled, arcgisTypeDefine, integrationError, integrationValidationArcGis } from "src/app/core/util/integration";
import { Items } from "src/app/core/util/itemsStatus";
import { allDialogProjectsLayerMap, externalProjectsGroupedByCompanyLayerMap, subLayersAccordionMap, subprojectLayerMap } from "src/app/core/util/mapModal";
import { ModalEnum, modalConfig } from "src/app/core/util/modalConfig";
import { showFeedbackError } from "src/app/core/util/notification";
import { translate } from "@jsverse/transloco";
import { GenericInfoModalComponent } from "src/app/shared/components/modal/generic-info-modal/generic-info-modal.component";
import { openDataAccordionMap } from "src/app/core/util/openDataModals";
import { ActiveLocationsStore } from "../../../../akita/active-locations/state/active-loacations.store";
import { Complaint } from "../../../../akita/complaints/state/complaint.model";
import { Issue } from "../../../../akita/issues/state/issue.model";
import { Decision } from "../../../../akita/requirements/state/decision.model";
import { SubprojectQuery } from "../../../../akita/subproject/state/subprojects.query";
import { GenericComponent } from "../../../../core/util/abstract/generic-component";
import { dateIso } from "../../../../core/util/dateIso";
import { Globals } from "../../../../globals";
import { AddOpenDataLayersComponent } from "../../../../shared/components/modal/add-open-data-layers/add-open-data-layers.component";
import { ItemLayersAccordionComponent } from "./item-layers-accordion/item-layers-accordion.component";
import * as turf from '@turf/turf';
import Bugsnag from "@bugsnag/js";
import { ContextService } from "src/app/core/service/api/context.service";
import { PaginationParams } from "src/app/core/service/common/pagination-params";
import { HttpParams } from "@angular/common/http";
import { SelectGeoJsonFileModalComponent } from "src/app/shared/components/modal/select-geo-json-file-modal/select-geo-json-file-modal.component";
import { DocumentsService } from "src/app/core/service/api/documents.service";
declare let ol: any;


@Component({
  selector: "app-openlayers-sidebar-v2",
  templateUrl: "./openlayers-sidebar-v2.component.html",
  styleUrls: ["./openlayers-sidebar-v2.component.sass"],
})
export class OpenlayersSidebarV2Component extends GenericComponent implements OnInit, OnDestroy {
  @Output() layerChange: EventEmitter<any> = new EventEmitter();
  @Output() selectedToolChange: EventEmitter<any> = new EventEmitter();
  @Output() purposeToolChange: EventEmitter<any> = new EventEmitter();
  @Output() polygonSelected: EventEmitter<any> = new EventEmitter();
  @Output() ontoggleOverpassLayer: EventEmitter<any> = new EventEmitter();
  @Output() ontoggleOpenDataLayers: EventEmitter<any> = new EventEmitter();
  @Output() newCreationOpenData: EventEmitter<any> = new EventEmitter();
  @Output() changeLayerStyle: EventEmitter<any> = new EventEmitter();
  @Output() loadPublicLayers: EventEmitter<any> = new EventEmitter();
  @Output() onClickExternalProject: EventEmitter<any> = new EventEmitter();
  @Output() onHoverOrLeaveExternalProjectName: EventEmitter<any> = new EventEmitter();
  @Input() buttons: string[] = ["layer", "length", "area"];
  @Input() collapse: boolean = false;
  @Input() contextPanel: boolean = false;
  @Input() contextGraph: boolean = false;
  @Input() displayProgressSpinner: boolean = false;
  @Input() defaultSelectedTool: string;
  @ViewChild("closeLayer") closeLayer: ElementRef;
  @ViewChild(ItemLayersAccordionComponent, { static: false }) public ItemLayersAccordion: ItemLayersAccordionComponent;
  paginator=new PaginationParams().with(["locations"]).whereHas(["locations"]);
  searchResults: any[] = [];
  showResultsContainer: boolean = false;
  private searchSubject = new Subject<string>();
  selectedResultIndex: number | null = null;
  private element: any;
  keyword: any
  private _tabitems: any;
  private _options: any;
  private _container: any;
  private _panes = [];
  private _closeButtons = [];
  public randomId = Math.random().toString(36).substring(7);
  public issues: Issue[] = [];
  public complaints: Complaint[] = [];
  public decisions: Decision[] = [];
  public activities: any = [];
  public integrationEnable: boolean = false;
  private aggregateTimeout: any;
  public createItem = false;
  public showLayers = true;
  public subProjectLayers = {};
  public itemsLocations = {
    stakeholder: [],
    issue: [],
    complaints: [],
    requirements: [],
    activity: [],
    physical: [],
    emotional: [],
    social: [],
    political: [],
    regulatory: [],
    irrelevant_contexts: []
  }
  public itemsFilter = {
    stakeholder: [],
    issue: [],
    complaints: [],
    requirements: [],
    activity: [],
  }
  public enableItemsLayer: Items = {
    subproject: false,
    stakeholder: false,
    issue: false,
    complaints: false,
    requirements: false,
    activity: false,
    physical: false,
    regulatory: false,
    political: false,
    social: false,
    emotional: false,
    ctx_stakeholders: false,
    ctx_issues: false,
    contactpersons: false,
    ctx_requirements: false,
    contactmoments: false,
    permits: false,
    contents: false,
    ctx_activities: false,
    ctx_complaints: false,
  };
  public enableLayerResidents = false;
  public enableLayerStakeholders = false;
  public enableLayerIssues = false;
  public enableLayerComplaints = false;
  public enableLayerDecisions = false;
  public enableLayerActivities = false;
  public enableStakeholdersPolygons = false;
  public potentialStakeholderToggle = false;
  public showToggles: boolean = true;
  public showContent: boolean = true;
  public issueRange: any;
  public issueMin: number;
  public issueMax: number;
  public complaintRange: any;
  public complaintMin: number;
  public complaintMax: number;
  public decisionRange: any;
  public decisionMin: number;
  public decisionMax: number;
  public layers = {
    arcgis: [],
    subproject: [],
    openData: [],
    allProjects: [],
    geojson: []
  };
  public externalProjectSearch = '';
  private rawAllProjects: any[] = [];
  private rawCustomerProjects: any[] = [];
  public activeContextGraphModules: string[] = ['emotional','social','regulatory','political','physical','stakeholders','issues', 'contactpersons',  'requirements', 'contactmoments', 'permits', 'contents', 'activities', 'complaints', 'contexts'];
  public cloneContextGraphModules: string[] = ['emotional','social','regulatory','political','physical','stakeholders','issues', 'contactpersons',  'requirements', 'contactmoments', 'permits', 'contents', 'activities', 'complaints', 'contexts'];
  public contextTypes: any = ['emotional','social','regulatory','political','physical'];
  public params = new HttpParams();
  public integrationCheck: string;
  public enableLayers = [];
  public selectedTool = "";
  public purposeTool = "";
  public tool = "";
  private subscriptions: Subscription[] = [];
  private geoJsonImportTrackingSub: Subscription | null = null;
  public loading: boolean = true;
  public loadingSearch: boolean = false;
  public is_loadOpenData: boolean = false;
  public is_loadAllProjects: boolean = false;
  public is_loadingGeoJsonData: boolean = true;
  public desableShow: boolean = false;
  public activeArcGis: string = 'arcgis';
  public togglerActivites: string;
  public errorIntegration: boolean = false;
  public isSharedSubproject = signal<boolean>(false);
  public errorIntegrationEnterprise: boolean = false;
  public arcGisLayers: any[] = [];
  public BBOX: any[] = [];
  @Input() type: string;
  constructor(
    private cd: ChangeDetectorRef,
    public globals: Globals,
    public _projectConfigsService: ProjectConfigsService,
    private subProjectQuery: SubprojectQuery,
    private activeLocationsStore: ActiveLocationsStore,
    public dialog: MatDialog,
    public _mapServices: MapService,
    public _contextsService: ContextService,
    private _documentsService: DocumentsService,
    public router: Router,
    private elementRef: ElementRef
  ) {
    super(globals);

    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged())
      .subscribe(res => {
        let stringUsingToString
        if (this.globals.projectConfig.polygons) {
          const feature = turf.polygon([this.globals.projectConfig.polygons.coordinates[0][0]]);
          // Calculate bounding box using Turf.js
          const bbox = turf.bbox(feature);
          // Bounding Box coordinates
          const boundingBox = `${bbox[0]}, ${bbox[1]}, ${bbox[2]}, ${bbox[3]}`;
          // Using toString method
          stringUsingToString = boundingBox.toString();
        }
        this._projectConfigsService.getMapAddress(res, stringUsingToString).subscribe((results: any[]) => {
          this.loadingSearch = false
          this.showResultsContainer = true;
          this.searchResults = results;

          this.cd.detectChanges(); // Manually trigger change detection

          // Remove existing markers

        });
      })


  }



  ngOnInit() {
    const activeSubProject = this.subProjectQuery.getActive();
    this.isSharedSubproject.set(activeSubProject && activeSubProject?.tenant_type === 'shared');
    this.activeArcGis = arcgisTypeDefine(this.globals);
    this.errorIntegration = integrationError(this.globals, 'arcgis_enabled');
    this.errorIntegrationEnterprise = integrationError(this.globals, 'arcgis_enterprise_enabled');
    if ((document.location.hostname === "app.getdialog.dev" || document.location.hostname === "app.getdialog.nl") && this.globals.project.customers && this.globals.project.customers.name && (this.globals.project.customers.name.toLowerCase().includes("van gelder") || this.globals.project.customers.name.toLowerCase().includes("company"))) {
      // enable the bulk adding feature
      this.enableStakeholdersPolygons = true;
    }
    this.integrationCheck = integrationValidationArcGis(this.globals, 'arcgis', 'arcgis_enterprise', 'arcgis_enabled', 'arcgis_enterprise_enabled', this.errorIntegration, this.errorIntegrationEnterprise);
    // Section visibility is independent of connection errors: show whenever the
    // integration is enabled at both project and user level (see arcGisSectionEnabled).
    this.integrationEnable = arcGisSectionEnabled(this.globals);
    // Layer loading still only runs when the integration is healthy (no connection
    // error); when it can't load, the visible section simply shows "no layers found".
    if (this.integrationCheck === 'project') {
      this.initIntegrationLayers();
    }

    // Hide Sidepanel in mobile Screen
    if (window.innerWidth <= 480) {
      document.querySelector("#sidebar").classList.add("collapsed");
      this.showContent = false;
    }


    this.togglerActivites = this.purposeTool;
    this.initDialogProjectsLayers();
    this.initControlSidebar();
    this.initSidebarClickEvents();
    this.initSidebarOpen();
    this.initSidebarClose();
    this.initSidebarSelectedTool();
    this.initSubProjectLayers();
    this.initGeoJsonLayers();
    this.loadOpenData();
  }

  onClickExternalProjectname(value: any){
    this.onClickExternalProject.emit(value)
  }

  onHoverOrLeaveExternalProjectTitle(value: any){
    this.onHoverOrLeaveExternalProjectName.emit(value);
  }

  search(term: string): void {
    if (term.trim() !== '') {
      this.loadingSearch = true
      this.searchSubject.next(term);
    } else {
      this.loadingSearch = false
      this.showResultsContainer = false; // Hide container when input is empty
      this._mapServices.vectorSource.clear();
      this._mapServices.popupOverlay.setPosition(undefined);
    }
  }

  panToLocation(result: any): void {
    this._mapServices.keyword = result.display_name;
    this._mapServices.vectorSource.clear();
    this._mapServices.setPanLocation(result)
  }

  onItemClick(index: number) {
    this.selectedResultIndex = index;
  }

  @HostListener('document:click', ['$event'])
  onClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    // Check if the clicked element is outside the search results container
    if (!clickedElement.classList.contains('search-result-item')) {
      this.showResultsContainer = false;
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }
  // on toggle all items
  public ontoggleChangeAllItem(event, type, action = false) {
    this.ItemLayersAccordion.ontoggleChangeAllItem(event, type, action);
  }

  public updateComplaintFilter(data): void {
    this.itemsLocations['complaints'] = this.itemsFilter['complaints']
      .filter((complaint: Complaint) => {
        const time = dateIso(complaint.date, true, this.globals.timezone).getTime();
        const splitsStart = data[0].split("-");
        const splitsEnd = data[1].split("-");
        const startTime = new Date(parseInt(splitsStart[2], 10), parseInt(splitsStart[1], 10) - 1, parseInt(splitsStart[0], 10));
        startTime.setHours(0, 0, 0, 0);
        const endTime = new Date(parseInt(splitsEnd[2], 10), parseInt(splitsEnd[1], 10) - 1, parseInt(splitsEnd[0], 10));
        endTime.setHours(23, 59, 59, 999);
        return time >= startTime.getTime() && time <= endTime.getTime();
      }).map((complaint) => complaint);
    clearTimeout(this.aggregateTimeout);
    this.aggregateTimeout = setTimeout(() => this.aggregateData(false), 300);
  }

  public updateIssueFilter(data): void {
    this.itemsLocations['issue'] = this.itemsFilter['issue']
      .filter((issue: any) => {
        const time = dateIso(issue.date, true, this.globals.timezone
        ).getTime();
        const splitsStart = data[0].split("-");
        const splitsEnd = data[1].split("-");
        const startTime = new Date(
          parseInt(splitsStart[2], 10),
          parseInt(splitsStart[1], 10) - 1,
          parseInt(splitsStart[0], 10)
        );
        startTime.setHours(0, 0, 0, 0);
        const endTime = new Date(
          parseInt(splitsEnd[2], 10),
          parseInt(splitsEnd[1], 10) - 1,
          parseInt(splitsEnd[0], 10)
        );
        endTime.setHours(23, 59, 59, 999);
        return time >= startTime.getTime() && time <= endTime.getTime();
      })
      .map((issue) => issue);

    clearTimeout(this.aggregateTimeout);
    this.aggregateTimeout = setTimeout(() => this.aggregateData(false), 300);
  }

  public formatFilter() {
    return {
      to: (value) => {
        if (value && typeof value === "number") {
          // We format the date by our self
          const dateObj = new Date(value);
          const date = (`0${dateObj.getDate()}`).slice(-2);
          const month = (`0${dateObj.getMonth() + 1}`).slice(-2);
          const year = dateObj.getFullYear();

          return `${date}-${month}-${year}`;
        }

        return value;
      },
      from: (value) => {
        return value;
      },
    };
  }

  public updateDecisionFilter(data): void {
    this.itemsLocations['requirements'] = this.itemsFilter['requirements']
      .filter((decision: any) => {
        if (!decision.date) {
          return false;
        }
        const decisionStart = dateIso(decision.date, true, this.globals.timezone);
        const decisionEnd = dateIso(decision.end_date, true, this.globals.timezone);
        const splitsStart = data[0].split("-");
        const splitsEnd = data[1].split("-");
        const startTime = new Date(
          parseInt(splitsStart[2], 10),
          parseInt(splitsStart[1], 10) - 1,
          parseInt(splitsStart[0], 10)
        );
        startTime.setHours(0, 0, 0, 0);
        const endTime = new Date(
          parseInt(splitsEnd[2], 10),
          parseInt(splitsEnd[1], 10) - 1,
          parseInt(splitsEnd[0], 10)
        );
        endTime.setHours(23, 59, 59, 999);
        if (!decisionEnd) {
          return decisionStart >= startTime && decisionStart <= endTime;
        }
        // Check if decision is within range of the filter
        // Done by negation of "outside range" situation
        return !(
          (decisionStart < startTime && decisionEnd < startTime) ||
          (decisionStart > endTime && decisionEnd > endTime)
        );

      })
      .map((decision) => decision);

    clearTimeout(this.aggregateTimeout);
    this.aggregateTimeout = setTimeout(() => this.aggregateData(false), 300);
  }

  public updateActivityFilter(data): void {
    this.itemsLocations['activity'] = this.itemsFilter['activity']
      .filter((activity: any) => {
        if (!activity.date) {
          return true;
        }
        const activityStart = dateIso(activity.date, true, this.globals.timezone);
        const activityEnd = dateIso(activity.end_date, true, this.globals.timezone);
        const splitsStart = data[0].split("-");
        const splitsEnd = data[1].split("-");
        const startTime = new Date(
          parseInt(splitsStart[2], 10),
          parseInt(splitsStart[1], 10) - 1,
          parseInt(splitsStart[0], 10)
        );
        startTime.setHours(0, 0, 0, 0);
        const endTime = new Date(
          parseInt(splitsEnd[2], 10),
          parseInt(splitsEnd[1], 10) - 1,
          parseInt(splitsEnd[0], 10)
        );
        endTime.setHours(23, 59, 59, 999);
        if (!activityEnd) {
          return activityStart >= startTime && activityStart <= endTime;
        }
        // Check if activity is within range of the filter
        // Done by negation of "outside range" situation
        return !(
          (activityStart < startTime && activityEnd < startTime) ||
          (activityStart > endTime && activityEnd > endTime)
        );

      })
      .map((activity: any) => activity);

    clearTimeout(this.aggregateTimeout);
    this.aggregateTimeout = setTimeout(() => this.aggregateData(false), 300);
  }
  //triger result
  private aggregateData(resetFilter: boolean = true, layer: any = false, toggle: boolean = true): void {
    const data = this.itemsLocations['stakeholder']
      .concat(this.itemsLocations['issue'])
      .concat(this.itemsLocations['complaints'])
      .concat(this.itemsLocations['requirements'])
      .concat(this.itemsLocations['activity'])
      .concat(this.itemsLocations['physical'])
      .concat(this.itemsLocations['political'])
      .concat(this.itemsLocations['emotional'])
      .concat(this.itemsLocations['regulatory'])
      .concat(this.itemsLocations['social'])
      .concat(this.itemsLocations['irrelevant_contexts']);
    this.activeLocationsStore.set(data);
    this.layerChange.emit({ data, resetFilter, layer, toggle });
    this.showToggles = true;
  }

  private initControlSidebar(): void {
    const self = this;
    ol.control.Sidebar = function (settings) {
      const defaults = {
        element: null,
        position: "left",
      };

      self._options = Object.assign({}, defaults, settings);

      self.element = document.querySelector(`.sidebar-${self.randomId}`);
      ol.control.Control.call(this, {
        element: self.element,
        target: self._options.target,
      });

      // Attach .sidebar-left/right class
      self.element.classList.add(`sidebar-${self._options.position}`);

      // Find sidebar > div.sidebar-content
      for (let i = self.element.children.length - 1; i >= 0; i--) {
        const child = self.element.children[i];
        if (
          child.tagName === "DIV" &&
          child.classList.contains("sidebar-content")
        ) {
          self._container = child;
        }
      }

      // Find sidebar ul.sidebar-tabs > li, sidebar .sidebar-tabs > ul > li
      self._tabitems = self.element.querySelectorAll(
        "ul.sidebar-tabs > li, .sidebar-tabs > ul > li"
      );
      for (let i = self._tabitems.length - 1; i >= 0; i--) {
        self._tabitems[i]._sidebar = this;
      }

      // Find sidebar > div.sidebar-content > div.sidebar-pane
      if (self._container) {
        for (let i = self._container.children.length - 1; i >= 0; i--) {
          const child = self._container.children[i];
          if (
            child.tagName == "DIV" &&
            child.classList.contains("sidebar-pane")
          ) {
            self._panes.push(child);

            const closeButtons = child.querySelectorAll(".sidebar-close");
            for (let j = 0, len = closeButtons.length; j < len; j++) {
              self._closeButtons.push(closeButtons[j]);
            }
          }
        }
      }


      for (let i = self._tabitems.length - 1; i >= 0; i--) {
        const child = self._tabitems[i];
        const sub = child.querySelector("a");
        if (
          sub.hasAttribute("href") &&
          sub.getAttribute("href").slice(0, 1) == "#"
        ) {
          sub.onclick = this._onClick.bind(child);
        }
      }

      for (let i = self._closeButtons.length - 1; i >= 0; i--) {
        const child = self._closeButtons[i];
        child.onclick = this._onCloseClick.bind(this);
      }
    };

    ol.inherits(ol.control.Sidebar, ol.control.Control);
  }

  private initSidebarClickEvents(): void {
    ol.control.Sidebar.prototype._onClick = function (evt) {
      evt.preventDefault();
      if (this.classList.contains("active")) {
        this._sidebar.close();
      } else if (!this.classList.contains("disabled")) {
        this._sidebar.open(this.querySelector("a").hash.slice(1));
      }
    };

    ol.control.Sidebar.prototype._onCloseClick = function () {
      this.close();
    };
  }

  private initSidebarOpen(): void {
    const self = this;
    ol.control.Sidebar.prototype.open = function (id) {
      let i, child;

      // hide old active contents and show new content
      for (i = self._panes.length - 1; i >= 0; i--) {
        child = self._panes[i];
        if (child.id == id) child.classList.add("active");
        else if (child.classList.contains("active"))
          child.classList.remove("active");
      }

      // remove old active highlights and set new highlight
      for (i = self._tabitems.length - 1; i >= 0; i--) {
        child = self._tabitems[i];
        if (child.querySelector("a").hash == `#${id}`)
          child.classList.add("active");
        else if (child.classList.contains("active"))
          child.classList.remove("active");
      }

      // open sidebar (if necessary)
      if (self.element.classList.contains("collapsed")) {
        self.element.classList.remove("collapsed");
      }

      return this;
    };
  }

  private initSidebarClose(): void {
    const self = this;
    ol.control.Sidebar.prototype.close = function () {
      // remove old active highlights
      for (let i = self._tabitems.length - 1; i >= 0; i--) {
        const child = self._tabitems[i];
        if (child.classList.contains("active"))
          child.classList.remove("active");
      }

      // close sidebar
      if (!self.element.classList.contains("collapsed")) {
        self.element.classList.add("collapsed");
      }

      return this;
    };
  }

  private initSidebarSelectedTool(): void {
    if (
      this.buttons.length > 0 &&
      this.defaultSelectedTool &&
      this.buttons.includes(this.defaultSelectedTool)
    ) {
      this.setSelectedTool(this.defaultSelectedTool);
    }
  }

  private initSubProjectLayers(): void {
    this.layers['subproject'] = subprojectLayerMap(this.subProjectQuery.getAll(), 'subproject');
  }

  private initDialogProjectsLayers(): void {
    this.is_loadAllProjects = true;
    this._mapServices.getAllDialogProjects().subscribe((res)=>{
      this.rawAllProjects = externalProjectsGroupedByCompanyLayerMap(res.external_projects || {}, 'allProjects');
      this.rawCustomerProjects = allDialogProjectsLayerMap(res.internal_projects, 'customerProjects');
      this.layers['allProjects'] = this.rawAllProjects;
      this.layers['customerProjects'] = this.rawCustomerProjects;
      this.globals.allProjects = res;
      this.is_loadAllProjects = false;
      this.cd.detectChanges();
    });
  }

  onExternalProjectSearch(term: string): void {
    this.externalProjectSearch = term;
    const lower = term.trim().toLowerCase();
    if (!lower) {
      this.layers['allProjects'] = this.rawAllProjects;
      this.layers['customerProjects'] = this.rawCustomerProjects;
      return;
    }
    // External projects: parent → company groups → projects
    this.layers['allProjects'] = this.rawAllProjects.map(parent => ({
      ...parent,
      sublayers: parent.sublayers
        .map((companyGroup: any) => ({
          ...companyGroup,
          sublayers: (companyGroup.sublayers || []).filter((p: any) =>
            (p.name || p.title || '').toLowerCase().includes(lower)
          ),
        }))
        .filter((companyGroup: any) => companyGroup.sublayers.length > 0),
    }));
    // Internal projects: parent → projects (flat)
    this.layers['customerProjects'] = this.rawCustomerProjects.map(parent => ({
      ...parent,
      sublayers: (parent.sublayers || []).filter((p: any) =>
        (p.name || p.title || '').toLowerCase().includes(lower)
      ),
    }));
  }

  sidebarClose() {
    document.querySelector("#sidebar").classList.add("collapsed");
    this.showContent = false;
  }

  public setSelectedTool(type: string): void {
    if(type === 'point') {
      this._mapServices.setData(undefined)
    }else {
      this._mapServices.setData(null)
    }
    // this.onLayerChange.emit([]);
    if (type !== "layer" && this.closeLayer) {
      // this.closeLayer.nativeElement.click();
    }

    this.selectedTool = type;
    this.purposeTool = type;
    this.togglerActivites = this.purposeTool;
    if (type === "add-stakeholder") {
      this.purposeTool = "add-stakeholder";
      type = "area";
    }
    if (type === "layer" || type === "draw") {
      this.createItem = !this.createItem;
      this.showLayers = !this.showLayers;
    }

    this.purposeToolChange.emit(this.purposeTool);

    switch (type) {
      case "point":
      case "area":
      case "length":
        this.selectedToolChange.emit(type);
        break;
      default:
        this.selectedToolChange.emit(null);
        break;
    }
  }

  public setTool(type: string): void {
    switch (type) {
      default:
        if (this.tool == type) {
          this.selectedToolChange.emit(null);
          this.tool = "";
        } else {
          this.selectedToolChange.emit(null);
          this.tool = "";
          this.selectedToolChange.emit({ type });
          this.tool = type;
        }
        break;
    }
  }
  //Overpass Layer load on map
  public toggleOverpassLayer(layer) {
    this.potentialStakeholderToggle = layer.checked;
    this.ontoggleOverpassLayer.emit(layer);
    this.cd.detectChanges();
  }

  public toggleOpenDataLayers(layersName) {
    this.ontoggleOpenDataLayers.emit(layersName);
  }

  public resetSelectedTool(): void {
    this.selectedTool = "";
  }
  /*
    ArcGis Integration Layers Setup
  */
  public async initIntegrationLayers() {
    this.desableShow = true;
    this.loading = false;
    // if (this.globals.enableLayers) {
    //   this.arcGisLayers = this.globals.enableLayers;
    //   await this.sleep(3000);
    //   this.setLayersResponce(this.arcGisLayers, 'name', 'arcgis');
    //   this.loading = true;
    //   this.cd.detectChanges();
    //   return true;
    // }
    combineLatest([
      this._projectConfigsService.getEnableFeatureLayers(this.activeArcGis),
      this._projectConfigsService.getFreshToken(this.activeArcGis)
    ])
      .pipe(
        tap(async ([layers, arcgis]) => {
          this.setArcGisSubLayers(layers, arcgis);
        }),
        catchError((err) => {
          Bugsnag.notify(JSON.stringify({
            message: 'ArcGis Account Is Not Verified',
            data: err,
          }));
          this.globals.projectConfigs['services.integration.arcgis.enabled'] = false;
          this.globals.projectConfigs['services.integration.arcgis_enterprise.enabled'] = false;
          showFeedbackError(err);
          return throwError(err);
        }),
      ).subscribe();
  }
  /*
    ArcGis Layers Into Sub Layers
  */
  public setArcGisSubLayers(layers: any, arcgis: any) {
    this.arcGisLayers = [];
    if (layers && layers.length) {
      layers.forEach(layer => {
        this._mapServices.getArcGisSubLayers(layer.url, arcgis.token)
          .pipe(
            tap(async (res: any) => {
              res.forEach(item => {
                let foundObject = null;
                if (layer.metadata) {
                  if (layer.metadata.length) {
                    foundObject = layer.metadata.find(data => data.layerId === item.id);
                  }
                }
                this.arcGisLayers.push({
                  id: layer.id,
                  name: layer.name,
                  main_layer_id: layer.id,
                  layer_name: item.name,
                  layer_id: item.id,
                  type: item.type,
                  geometry_type: item.geometryType,
                  url: layer.url,
                  owner: layer.owner,
                  enabled: layer.enabled,
                  metadata: foundObject ? foundObject.metadata : null,
                  alldata: layer.metadata ? layer.metadata : null,
                });
              });
              await this.sleep(3000);
              this.setLayersResponce(this.arcGisLayers, 'name', 'arcgis');
              this.globals.enableLayers = this.arcGisLayers;
              this.loading = true;
              this.cd.detectChanges();
            }),
            catchError((err) => {
              if (err?.arcgisError && err?.code === 403) {
                if (!this._mapServices.isArcgisErrorModalOpen) {
                  this._mapServices.isArcgisErrorModalOpen = true;
                  this.dialog.open(GenericInfoModalComponent, modalConfig(
                    {
                      data: {
                        title: translate('error.arcgis_item_unavailable_title'),
                        body: translate('error.arcgis_item_unavailable'),
                      },
                      disableClose: false,
                      panelClass: 'customized-dialog-container'
                    },
                    ModalEnum.ModalSmall
                  )).afterClosed().subscribe(() => {
                    this._mapServices.isArcgisErrorModalOpen = false;
                  });
                }
                this.loading = true;
                this.cd.detectChanges();
                return EMPTY;
              }
              return throwError(() => err);
            })
          ).subscribe();
      });
    } else {
      this.globals.enableLayers = this.arcGisLayers;
      this.loading = true;
      this.cd.detectChanges();
    }
  }
  //set layer responce
  public setLayersResponce(response, unique, type) {
    this.layers[type] = subLayersAccordionMap(response, unique, type);
  }
  //on change style
  public onChangeStyle(layer) {
    this.changeLayerStyle.emit(layer)
  }
  //on items select
  public async toggleitemsLayers(map) {
    if(this.contextGraph){
      if (map.type==='default') {
        this.params = new HttpParams();
        this.activeContextGraphModules = ['emotional','social','regulatory','political','physical','stakeholders','issues', 'contactpersons',  'requirements', 'contactmoments', 'permits', 'contents', 'activities', 'complaints', 'contexts'];
        this.cloneContextGraphModules.forEach(module => {
          if (this.contextTypes.includes(module)) {
            this.params = this.params.append('filter_array[types.name][]', module);
          } else {
            this.params = this.params.append('modules[]', module);
          }
        });
        this.emitContextItems();
        return;
      }
      this.updateContextTypes(map.type, map?.event?.checked);
      this.emitContextItems();
      return;
    }
    this.enableItemsLayer[map.type] = map.item.status;
    if (this.contextPanel && this.contextTypes.includes(map.type)) {
      await this.initSuggestedContextsItems();
    }
    this.itemsLocations[map.type] = map.location;
    this.itemsFilter[map.type] = map.location;
    this.aggregateData(true, map.item, map.toggle);

    this._mapServices.setOverlayPopup(map.location)
    if (map.action)
      this.newCreationOpenData.emit();
  }
  //add open data layers modal
  public addOpenDataLayers() {
    const dialog = this.dialog.open(AddOpenDataLayersComponent, modalConfig({
      panelClass: ['animate__animated', 'animate__slideInUp'],
      disableClose: true,
      closeOnNavigation: true
    }, ModalEnum.ModalSmall));
    dialog.afterClosed().subscribe((response: any) => {
      if (response) {
        this.loadOpenData();
      }
    });
  }
  //load all open data function
  public loadOpenData() {
    this.is_loadOpenData = true;
    this.cd.detectChanges()
    this._mapServices.getOpenData()
      .pipe(
        tap(res => {
          const openData = res.filter(item => (item.type!=='geojson'));
          this.layers['openData'] = openDataAccordionMap(openData);
          this.loadPublicLayers.emit();
          this.is_loadOpenData = false;
          this.cd.detectChanges()
        })
      ).subscribe();
  }
  /*
    Sleep function for map loadding
  */
  public sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms))
  }


  initSuggestedContextsItems(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.paginator._filters = {
        'types.name': ['physical', 'social', 'political', 'emotional', 'regulatory']
      };
      this.paginator.orderBy('id');
      this.paginator.with(["locations,types"]);

      // Get enabled context types from enableItemsLayer
      const enabledContextTypes = this.contextTypes.filter(contextType => 
        this.enableItemsLayer[contextType] === true
      );
      
      forkJoin({
        irrelevantContexts: this._contextsService.getIrrelevantContextItems(enabledContextTypes),
        // irrelevantContexts: of([data]),
        allContexts: this._contextsService.getAllContexts(this.paginator)
      }).subscribe({
        next: ({ irrelevantContexts, allContexts }: any) => {
          let emitValues: any = {};

          emitValues.location = irrelevantContexts
            .filter((item: any) => {
              return !item.is_relevant && this.contextTypes.includes(item.type) && this.enableItemsLayer[item.type];
            })
            .map((context) => {
              const id = context.uuid;
              let points = context.locations?.points;
              let lines = context.locations?.lines;
              let polygons = context.locations?.polygons;

              if (polygons) {
                polygons = {
                  type: "MultiPolygon",
                  coordinates: polygons.type === "MultiPolygon" ? polygons.coordinates : [polygons.coordinates]
                };
              } else if (points) {
                points = {
                  type: "MultiPoint",
                  coordinates: points.type === "MultiPoint" ? points.coordinates : [points.coordinates]
                };
              } else if (lines) {
                lines = {
                  type: "MultiLine",
                  coordinates: lines.type === "MultiLine" ? lines.coordinates : [lines.coordinates]
                };
              }

              context.locations = {
                id,
                name: context.text,
                is_relevant: false,
                locatable_type: 'irrelevant_contexts',
                locatable_id: id,
                types: {name: context.type},
                complete_item: context,
                link: `irrelevant_contexts/${id}`,
                points,
                lines,
                polygons
              };
              return context.locations;
            })
            // Remove duplicated items based on name and is_relevant
            .filter((item: any, index: number, self: any) =>
              index === self.findIndex((t: any) => t.name === item.name && t.is_relevant === item.is_relevant)
            )

          emitValues.item = {
            layer: 'irrelevant_contexts',
            status: true
          };
          emitValues.toggle = true;
          emitValues.type = 'irrelevant_contexts';

          this.itemsLocations['irrelevant_contexts'] = emitValues.location;
          this.itemsFilter['irrelevant_contexts'] = emitValues.location;

          resolve();
        },
        error: (err) => {
          console.error('Failed to load context items:', err);
          reject(err);
        }
      });
    });
  }

  private updateContextTypes(type: string, isActive: boolean): void {
    const transformedType = this.transformGraphType(type);
    const index = this.activeContextGraphModules.indexOf(transformedType);
    if (isActive && index === -1) {
      this.activeContextGraphModules.push(transformedType);
    } else if (!isActive && index !== -1) {
      this.activeContextGraphModules.splice(index, 1);
    }
    this.updateHttpParamsFromModules();
  }

  private transformGraphType(type: string): string {
    let normalized = type.startsWith('ctx_') ? type.replace('ctx_', '') : type;
    const customPlurals: Record<string, string> = {
      stakeholder: 'stakeholders',
      issue: 'issues',
      requirements: 'requirements',
      complaint: 'complaints',
      activity: 'activities',
      context: 'contexts',
      contactpersons: 'contactpersons',
      contactmoments: 'contactmoments',
      permit: 'permits',
      content: 'contents',
      type: 'types'
    };

    return customPlurals[normalized] || normalized;
  }

  private updateHttpParamsFromModules(): void {
    this.params = new HttpParams();
    const hasContextType = this.activeContextGraphModules.some(module =>
      this.contextTypes.includes(module)
    );
    if (!hasContextType){
      this.activeContextGraphModules = this.activeContextGraphModules.filter(
        module => module !== 'contexts'
      );
    } else if(hasContextType && !this.activeContextGraphModules.includes('contexts')){
      this.activeContextGraphModules.push('contexts');
    }
    this.activeContextGraphModules.forEach(module => {
      if (this.contextTypes.includes(module)) {
        this.params = this.params.append('filter_array[types.name][]', module);
      } else {
        this.params = this.params.append('modules[]', module);
      }
    });
  }

  emitContextItems(){
    this._contextsService.getAllContextsSummary(this.params).subscribe((res) => {
      this.showToggles=true;
      this.layerChange.emit(res);
    })
  }
  
  private initGeoJsonLayers(): void {
    this.is_loadingGeoJsonData = true;
    this._documentsService.getSavedGeoJsonLayers().subscribe((res: any)=>{
      this.layers['geojson'] = res.filter(item => (item.type=='geojson'));
      this.is_loadingGeoJsonData = false;
      this.cd.detectChanges();
    }, (err: any)=>{
      this.is_loadingGeoJsonData = false;
      this.cd.detectChanges();
    });
  }

  private trackGeoJsonImportAndRefresh(processId?: number | null): void {
    if (!processId) {
      this.initGeoJsonLayers();
      return;
    }

    if (this.geoJsonImportTrackingSub) {
      this.geoJsonImportTrackingSub.unsubscribe();
    }

    this.geoJsonImportTrackingSub = interval(4000).pipe(
      switchMap(() => this._projectConfigsService.broadcastingProcess(processId)),
      takeWhile((res: any) => res.ok, true)
    ).subscribe({
      complete: () => this.initGeoJsonLayers()
    });
    this.subscriptions.push(this.geoJsonImportTrackingSub);
  }

  public openGeoJsonModal(){
    const dialog = this.dialog.open(SelectGeoJsonFileModalComponent, modalConfig({
      data: {
        type: 'json',
        onImportSuccess: (processId?: number | null) => this.trackGeoJsonImportAndRefresh(processId)
      },
      disableClose: true,
      panelClass: 'customized-dialog-container',
    }, ModalEnum.ModalMedium))
  }
}
